/**
 * User role types and enums shared between client and server
 */
// User roles enum
export var UserRole;
(function (UserRole) {
    UserRole["SYSTEM_ADMIN"] = "SYSTEM_ADMIN";
    UserRole["UNIVERSITY_ADMIN"] = "UNIVERSITY_ADMIN";
    UserRole["FACULTY_ADMIN"] = "FACULTY_ADMIN";
    UserRole["PROFESSOR"] = "PROFESSOR";
    UserRole["COURSE_REPRESENTATIVE"] = "COURSE_REPRESENTATIVE";
})(UserRole || (UserRole = {}));
//# sourceMappingURL=user-roles.js.map